module.exports = __webpack_public_path__ + "static/media/c-pop-up-7.cdeba4b9.png";